<template>
  <div>
    <CoverBg
      show-text
      title="Why work hear?"
      text="Find Your Dream Job at STATECS"
    />
    <b-container class="main-container content-padding-t-b-100">
      <Paragraph
        :paragraph="whyWorkHearContext.mainContext"
        p-distance
        p-item-distance
        class="m-b-100"
      />

      <b-row class="careers-buttons m-b-100">
        <b-col
          lg="6"
          sm="12 text-center"
          class="pb-2"
        >
          <b-button
            class="btn-main-bg-blue
            btn-main-bg-blue-careers-btn"
            @click="$router.push({
              name: R_VACANCIES,
            })"
          >
            Vacancies
          </b-button>
        </b-col>
        <b-col
          lg="6"
          sm="12 text-center"
          class="pb-2"
        >
          <b-button
            class="btn-main-bg-blue
            btn-main-bg-blue-careers-btn"
            @click="$router.push({
              name: R_SAS_TRAININGS,
            })"
          >
            SAS Trainings
          </b-button>
        </b-col>
      </b-row>

      <div class="employees">
        <h3
          class="font-weight-bold f-s-44 l-h-65 l-s-175 m-b-74"
        >
          What Our Employees Say
        </h3>

        <EmployeeItem
          v-for="(employee, i) in whyWorkHearContext.employeesOptions"
          :key="i"
          :item="employee"
          :idx="i"
        />
      </div>
    </b-container>
    <CoverBg bg="cover-bg-page-bottom" />
  </div>
</template>

<script>
import CoverBg from '@/components/CoverBg';
import whyWorkHearContext from '@/constants/whyWorkHearContext';
import Paragraph from '@/components/Paragraph';
import EmployeeItem from '@/components/EmployeeItem';
import { R_VACANCIES, R_SAS_TRAININGS } from '@/router/routes';

export default {
  name: 'Careers',
  components: { EmployeeItem, Paragraph, CoverBg },
  data() {
    return {
      whyWorkHearContext,
      R_VACANCIES,
      R_SAS_TRAININGS,
    };
  },
  methods: {
    redirectTo(routeName) {
      this.$router.push({
        name: routeName,
      });
    },
  },
};
</script>
